/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ESidePanelContent } from '../../models';

export interface ISidePanelState {
  isSidePanelOpened: boolean;
  sidepanelContent: ESidePanelContent;
  /** Whether the map / overlay controls should offset to make room for the side panel (true only on desktop). */
  shouldOffsetForSidePanel: boolean;
}

export const initialSidePanelState: ISidePanelState = {
  isSidePanelOpened: false,
  sidepanelContent: ESidePanelContent.None,
  shouldOffsetForSidePanel: false
};
